<template>
  <div>
    <!-- 新增按钮 -->

    <Select
      v-model="searchType"
      placeholder="请选择审核分类"
      style="width: 200px; margin-right: 10px"
    >
      <Option
        v-for="item in goodstypeOptions"
        :value="item.value"
        :key="item.value"
        >{{ item.label }}</Option
      >
    </Select>
    <Button type="primary" @click="queryGoods">查询</Button>

    <Table :columns="columns10" :data="data9"> </Table>
  </div>
</template>

<script>
import SingleUpload from "@/components/Upload/singleUpload";
import { cmsSelMoneyApply, cmsUpdateMoneyApply } from "../../api/moneyApply";

const TYPE = [
  { value: 0, label: "金币" },
  { value: 1, label: "能量" },
  { value: 2, label: "礼品" },
];
export default {
  components: { SingleUpload },
  data() {
    return {
      goodstypeOptions: TYPE,
      loading: false,
      data9: [], // 用于存储查询结果
      columns10: [
        {
          title: "申请时间",
          key: "createtime",
        },
        {
          title: "申请人",
          key: "createpeo",
        },
        {
          title: "申请金币数/能量数/礼品id",
          key: "applycoin",
        },
        {
          title: "通过后金币数/能量数/礼品名",
          key: "user_name",
          render: (h, params) => {
            if (params.row.applytype === 0) {
              //充值
              if (params.row.applystatus === 0) {
                return h(
                  "span",
                  parseInt(params.row.applycoin) + parseInt(params.row.balance),
                );
              } else {
                return h(
                  "span",
                  parseInt(params.row.balance) -
                    parseInt(params.row.applycoin) <
                    0
                    ? 0
                    : parseInt(params.row.balance) -
                        parseInt(params.row.applycoin),
                );
              }
            } else if (params.row.applytype === 1) {
              if (params.row.applystatus === 0) {
                return h(
                  "span",
                  parseInt(params.row.applycoin) +
                    parseInt(params.row.integral),
                );
              } else {
                return h(
                  "span",
                  parseInt(params.row.integral) -
                    parseInt(params.row.applycoin) <
                    0
                    ? 0
                    : parseInt(params.row.integral) -
                        parseInt(params.row.applycoin),
                );
              }
            } else {
              return h("span", params.row.product);
            }
          },
        },
        {
          title: "申请类型",
          key: "applytype",
          render: (h, params) => {
            const applytype = params.row.applystatus;
            return h("span", applytype == 0 ? "充值" : "扣除");
          },
        },
        {
          title: "充值用户id",
          key: "user_id",
        },
        {
          title: "充值用户昵称",
          key: "user_name",
        },
        {
          title: "充值/扣除理由",
          key: "reasontxt",
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "center",
          render: (h, params) => {
            const idstatus = params.row.idstatus;

            if (idstatus === 1) {
              return h("span", "已通过");
            }

            if (idstatus === 2) {
              return h("span", "已拒绝");
            }

            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.shenhe(params.row, 1); // 传入当前行的商品信息
                    },
                  },
                },
                "通过",
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.shenhe(params.row, 2); // 传入当前行的商品信息
                    },
                  },
                },
                "拒绝",
              ),
            ]);
          },
        },
      ],
      searchType: 0,
    };
  },
  mounted() {
    this.queryGoods();
  },
  methods: {
    shenhe(row, status) {
      cmsUpdateMoneyApply({ id: row.id, idstatus: status })
        .then((response) => {
          this.$Message.success("操作成功");
          this.queryGoods();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    // 查询商品
    // 公共查询函数
    fetchGoodsData(params = {}) {
      cmsSelMoneyApply(params)
        .then((response) => {
          this.data9 = response.data; // 获取查询结果
        })
        .catch((error) => {
          console.error(error);
        });
    },
    // 验证输入的是否为正整数
    validatePositiveInteger(value) {
      if (value < 1 || !Number.isInteger(+value)) {
        this.$Message.error("请输入一个正整数");
        this.newGoodsNum = "";
      }
    },
    // 查询商品
    queryGoods() {
      const params = {
        applytype: this.searchType,
      };
      this.fetchGoodsData(params);
    },
  },
};
</script>
